import Table from "react-bootstrap/Table";
import React from "react";

export const UiTable = (props) => {
    const theader = props.tableHeader;
    return (
        <Table  hover className={props.className}>
            <thead>
                <tr>
                    {theader.map((thItem, index) => (
                        <th key={index}>{thItem.th}</th>
                    ))}
                </tr>
            </thead>
            <tbody>{props.children}</tbody>
        </Table>
    );
};
